import { makeVar } from '@apollo/client';

export const pendingOrderBookGridForcedRefreshVar = makeVar(false);
// Since there is no connection on the toolbar and the route for the grid
// we need to have a variable on the book
export const showOrderBookGridToolBarOptions = makeVar(true);
